import * as t from "io-ts";
import * as ProbateInterestedInStateNoUnknown from "./ProbateInterestedInStateNoUnknown";

export const codec = t.union([
    t.literal("unknown"),
    ProbateInterestedInStateNoUnknown.codec,
]);
